import { OtDataDrivenDefinition } from '@/wf-components/models/data-driven-definition';
import json from './contract-workflow-definition.json';

export const ContractWorkflowDefinitions = OtDataDrivenDefinition.createFromJson(json as never);

export default ContractWorkflowDefinitions;
